export default __webpack_public_path__ + "static/media/pic_uploadImage.2bdd9de4.svg";